import React, { Component } from 'react'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import 'react-datepicker/dist/react-datepicker.css'
import AlertModal from '../CommonControlls/AlertModal'
import { SyncConfig } from '../OfflineDb/ConfigDataSync'
import DropDown from '../CommonControlls/DropdownRendrer'

const mapStateToProps = (store) => {
  return store
}

const mapDispatchToProps = (dispatch) => {
  return {
    ShowAlert: (Settings) => {
      dispatch({ type: 'UpdateAlert', payload: Settings })
    },
    ShowLoader: (Isloading) => {
      dispatch({ type: 'UpdateLoader', payload: Isloading })
    },
  }
}

class Patients_Add extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Id: 0,
      DOB: null,
      hcfId: null,

      alertModalData: {
        title: '',
        message: '',
        First_Callback: () => { },
        Second_Callback: () => { },
        type: 1,
      },

      Genderlist: [
        { id: 1, label: 'Male' },
        { id: 2, label: 'Female' },
        { id: 3, label: 'Other' },
      ],
      GenderId: 1,
      is_clinicallyDiagnosed: false,
    }
  }

  HandleDateChange = (Field, date) => {
    this.setState({
      [Field]: date,
    })

    if (date == '' || date == null) {
      $('#PatientAge').val('')
    } else {
      var tempres = Common.getAge(date)
      $('#PatientAge').val(tempres.Age)
    }
  }

  HandleAutoSuggestValChange = (fieldId, value) => {
    this.setState({ [fieldId]: value })
  }

  componentWillMount() {
    if (this.props.UserAuthentication.AuthToken === '') {
      this.props.history.push('/Login')
    }
  }

  componentDidMount() {
    Common.AddClassToMenueLink('MenuLink_Patients')
    var Id = Common.GetId()
    if (Id != 0) {
      this.selectPatientDetails(Id)
    }
  }

  selectPatientDetails = async (PatientId) => {
    this.props.ShowLoader({ Isloading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.Get_Patient,
      { PatientId, sortField: 'id', sortOrder: 'asc' },
      (resp) => {
        if (resp.status == true) {
          this.LoadDataInEditMode(resp?.data[0])
        }
        this.props.ShowLoader({ Isloading: false })
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wrong, please try again.',
        })
        setTimeout(() => {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }

  LoadDataInEditMode = (data) => {
    this.setState({
      is_clinicallyDiagnosed: data.is_clinicallyDiagnosed,
      hcfId: data.hcfId,
      Id: data.id,
      GenderId: data.gender,
      DOB:
        data.dob == null
          ? null
          : new Date(Common.ConvertToLocalDateTime(data.dob)),
    })

    $('#Patientname').val(data.name)
    $('#Patientcontact').val(data.contact)
    $('#PatientCNIC').val(data.cnic)
    $('#Patientemail').val(data.email)
    $('#PatientAge').val(data.age)
    $('#PatientAddress').val(data.address)
  }

  ResetForm = () => {
    this.setState({
      Id: 0,
      GenderId: 1,
      DOB: null,
    })
    $('#Patientname').val('')
    $('#Patientcontact').val('')
    $('#PatientCNIC').val('')
    $('#Patientemail').val('')
    $('#PatientAge').val('')
    $('#PatientAddress').val('')
  }

  SubmitForm = (e) => {
    e.preventDefault()

    if (this.state.GenderId == 0) {
      this.props.ShowAlert({ Type: 0, Msg: 'Please select gender' })
      setTimeout(() => {
        $('#Alertmsgbtn').click()
      }, 50)
      return
    }

    this.props.ShowLoader({ Isloading: true })
    var Parameters = {
      id: this.state.Id,
      name: $('#Patientname').val(),
      contact: $('#Patientcontact').val(),
      email: $('#Patientemail').val(),
      // dob:this.state.DOB==null?null: Common.ConvertToUtcDateTime(this.state.DOB),
      age: $('#PatientAge').val(),
      address: $('#PatientAddress').val(),
      gender: this.state.GenderId,
      cnic: $('#PatientCNIC').val(),
      hcfId: this.state.hcfId,
    }

    if (this.state.is_clinicallyDiagnosed) {
      Parameters.is_clinicallyDiagnosed = this.state.is_clinicallyDiagnosed
    }

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Post',
      false,
      this.state.Id == 0
        ? Common.APILinks.Save_Patient
        : Common.APILinks.Update_Patient,
      JSON.stringify(Parameters),
      (resp) => {
        if (resp.status == true) {
          SyncConfig(
            () => {
              if (this.state.Id != 0) $('#Form_ResetBtn').click()
              this.ResetForm()
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({ Type: 1, Msg: 'Saved successfully' })
              setTimeout(() => {
                $('#Alertmsgbtn').click()
              }, 50)
            },
            () => {
              if (this.state.Id != 0) $('#Form_ResetBtn').click()
              this.ResetForm()
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({
                Type: 0,
                Msg: 'Error in sync, please reload the page',
              })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
          )
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: resp.message })
          setTimeout(() => {
            $('#Alertmsgbtn').click()
          }, 50)
        }
        this.props.history.push('/Patients')
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wronge, please try again.',
        })
        setTimeout(() => {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }

  onDelete = () => {
    this.setState(
      {
        alertModalData: {
          title: 'Delete Patient',
          message: 'Are you sure you want to delete this record.',
          First_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
            this.DeleteRecord()
          },
          Second_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
          },
          type: 1,
        },
      },
      () => {
        $('#Show_ArletModal').click()
      },
    )
  }

  DeleteRecord = () => {
    this.props.ShowLoader({ Isloading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.Delete_Patient,
      { id: this.state.Id },
      (Result) => {
        if (Result.status == true) {
          SyncConfig(
            () => {
              $('#Form_CancelBtn').click()
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({ Type: 1, Msg: 'Deleted Successfully.' })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
            () => {
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({
                Type: 0,
                Msg: 'Error in sync, please reload the page',
              })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
          )
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: Result.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wronge, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }

  render() {
    return (
      <div>
        <AlertModal {...this.state.alertModalData} />
        <MainLayout />
        <div id="right-panel" class="right-panel">
          <Topmenu
            PageTitle={this.state.Id == 0 ? 'Add Patient' : 'Edit Patient'}
            isShowAddBtn={false}
          />
          <div class="content">
            {/* <div class="PageHeader_Container">
                <h2>{this.state.Id==0?"Add Patient":"Edit Patient"}</h2>
            </div> */}

            <div class="card col-md-5 col-lg-5">
              <div class="card-body row">
                <div class="">
                  <form onSubmit={this.SubmitForm} novalidate>
                    <div class="row">
                      <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label for="">
                          <span style={{ color: 'red' }}>* </span>Name
                        </label>
                        <input
                          autocomplete="off"
                          type="text"
                          class="form-control"
                          id="Patientname"
                          placeholder="Enter patient name"
                          required
                        />
                      </div>

                      <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label for="">
                          <span style={{ color: 'red' }}>* </span>Phone
                        </label>
                        <input
                          autocomplete="off"
                          pattern="[0][0-9]{10}"
                          type="text"
                          class="form-control"
                          id="Patientcontact"
                          placeholder="Enter patient phone - 03123456789"
                          required
                        />
                      </div>

                      <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label for="">
                          <span style={{ color: 'red' }}>* </span>Age
                        </label>
                        <input
                          class="form-control"
                          id="PatientAge"
                          type="number"
                          placeholder="Enter patient age"
                          required
                        />
                      </div>

                      <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label for="">
                          <span style={{ color: 'red' }}>* </span>Gender
                        </label>
                        <DropDown
                          multi={false}
                          dropdownRenderer={false}
                          create={false}
                          onChange={this.HandleAutoSuggestValChange}
                          Type="GenderId"
                          options={this.state.Genderlist}
                          val={this.state.GenderId}
                          addPlaceholder=""
                          disabled={false}
                          loading={false}
                          searchBy="label"
                          labelField="label"
                          valueField="id"
                          contentRenderer={false}
                          placeholder="Select"
                        />
                      </div>

                      <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label for="">CNIC/B-Form #</label>
                        <input
                          class="form-control"
                          id="PatientCNIC"
                          type="text"
                          placeholder="Enter patient CNIC/B-Form #"
                        />
                      </div>

                      <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label for="">Email</label>
                        <input
                          autocomplete="off"
                          type="email"
                          class="form-control"
                          id="Patientemail"
                          placeholder="Enter patient email"
                        />
                      </div>

                      {/* <div class="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                    <label for="">DOB</label>
                                    <DatePicker
                                        selected={this.state.DOB}
                                        onChange={((date)=>{this.HandleDateChange("DOB",date)})}
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        maxDate={new Date()}
                                    />
                                </div> */}

                      <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label for="">Address</label>
                        <textarea
                          autocomplete="off"
                          class="form-control"
                          placeholder="Enter patient address"
                          id="PatientAddress"
                          rows="3"
                        ></textarea>
                      </div>

                      {Common.GetId() !== 0 && (
                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <label htmlFor="is_clinicallyDiagnosed">
                            <input
                              type="checkbox"
                              id="is_clinicallyDiagnosed"
                              checked={this.state.is_clinicallyDiagnosed}
                              onChange={(e) =>
                                this.setState({
                                  is_clinicallyDiagnosed: e.target.checked,
                                })
                              }
                            />{' '}
                            Clinically Diagnosed
                          </label>
                        </div>
                      )}

                      <div class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <button
                          type="submit"
                          id="Form_SaveBtn"
                          class="btn btn_style1"
                        >
                          {Common.GetId() !== 0 ? 'Update' : 'Save'}
                        </button>
                        <button
                          type="button"
                          id="Form_DeleteBtn"
                          onClick={this.onDelete}
                          hidden={this.state.Id == 0 ? true : false}
                          class="btn btn_style2"
                        >
                          Delete
                        </button>
                        <Link to="/Patients">
                          <button
                            type="button"
                            id="Form_CancelBtn"
                            class="btn btn_style3"
                          >
                            Cancel
                          </button>
                        </Link>

                        {/* Hide button for reset */}
                        <Link style={{ display: 'none' }} to="/Patients_Add">
                          <button
                            id="Form_ResetBtn"
                            type="button"
                            class="btn initial-btn Cancel-Form-btn Form_Btn"
                          >
                            Reset
                          </button>
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Patients_Add)
